'use client';

import React, { Fragment, useEffect } from 'react';

import useBreakpoint from '@/hooks/useBreakpoint';

import HomePaginaMobile from './Designs/Mobile';
import HomePaginaDesktop from './Designs/Desktop';
import { useHomeData } from '@/hooks/useHomeData';
import useHomeHook from './hook/useHomeHook';
import { UniversalScrollTracker } from '@/components/organisms/UniversalScrollTracker';

export default function HomePagina() {
  const { breakpoint } = useBreakpoint();
  const {
    recuperarCategorias,
    recuperarProdutos,
    recuperarCombos,
    recuperarAssinaturas,
    recuperarTiposDenunciaResenha,
    recuperarEmAltaStreaming,
    recuperarFilmesEmCartaz,
  } = useHomeData();

  useEffect(() => {
    recuperarCategorias();
    recuperarProdutos();
    recuperarCombos();
    recuperarAssinaturas();
    recuperarTiposDenunciaResenha();
    recuperarEmAltaStreaming();
    recuperarFilmesEmCartaz();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useHomeHook();

  return (
    <Fragment>
      <UniversalScrollTracker pagina="home" />
      {breakpoint === 'mobile' ? <HomePaginaMobile /> : <HomePaginaDesktop />}
    </Fragment>
  );
}
